<template>
  <div
    class="hover-card flex flex-col overflow-hidden"
    :class="{ 'card-lg': size === 'lg' }"
  >
    <div
      class="flex flex-col"
      :class="size === 'lg' ? 'gap-2 p-4' : 'gap-3 p-4'"
    >
      <div class="flex items-center gap-2">
        <!-- Product image or icon component -->
        <img
          v-if="imgUrl"
          :src="imgUrl"
          :alt="title"
          class="w-5 h-5 rounded-md object-cover shrink-0"
        >
        <component
          :is="icon"
          v-else-if="icon"
          :width="iconSize"
          :height="iconSize"
          class="text-white shrink-0"
        />
        <BaseText
          type="label"
          size="sm"
          class="flex-1 text-white"
        >
          {{ title }}
        </BaseText>
        <!-- <div
          v-if="size === 'lg' && value"
          class="px-1.5 py-0.5 rounded-md bg-neutral-alpha-100"
        >
          <BaseText
            type="label"
            size="xs"
            class="text-white whitespace-nowrap"
          >
            {{ value }}
          </BaseText>
        </div> -->
      </div>
      <BaseText
        type="body"
        size="sm"
        class="text-neutral-alpha-650"
      >
        {{ description }}
      </BaseText>
    </div>
    <img
      v-if="size === 'lg' && image"
      :src="image"
      :alt="`${title} preview`"
      class="block w-full h-auto mt-auto"
    >
  </div>
</template>

<script>
export default {
  name: 'PlanFeatureHoverCard',
  props: {
    // 'lg' renders the plan value and product preview image, 'sm' is title + description only
    size: {
      type: String,
      default: 'lg',
      validator: value => ['lg', 'sm'].includes(value)
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    imgUrl: {
      type: String,
      default: null
    },
    icon: {
      type: [Object, Function],
      default: null
    },
    iconSize: {
      type: Number,
      default: 16
    },
    image: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
.hover-card {
  background: rgba(17, 18, 23, 1);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 16px;
  backdrop-filter: blur(100px);
  /* Width is set by the positioned container in PlanFeatureList */
  width: 100%;
}
.card-lg {
  height: 364px;
}
</style>
